import React from 'react';
import { Col as BootstrapCol } from 'react-bootstrap';

const Col = ({ 
    children, 
    xs, 
    sm, 
    md, 
    lg, 
    xl, 
    xxl,
    isMobile = false, 
    isTablet = false, 
    isDesktop = false, 
    style, 
    className,
    ...props 
}) => {
    return (
        <BootstrapCol 
            xs={xs} 
            sm={sm} 
            md={md} 
            lg={lg} 
            xl={xl} 
            xxl={xxl}
            className={className} 
            style={style}
            {...props}
        >
            {children}
        </BootstrapCol>
    );
};

export default Col;

